"use client";

import { c as _c } from "react/compiler-runtime";
import { useActionState, useState } from "react";
import { submitPhone } from "./actions";
import { AuthPageLayout, AuthCard } from "../components";
import styles from "../shared.module.css";
export interface FormState {
  error?: string;
}
const initialState: FormState = {};
interface LoginFormProps {
  returnTo?: string;
}
export function LoginForm(t0) {
  const $ = _c(22);
  const {
    returnTo
  } = t0;
  const [state, formAction, isPending] = useActionState(submitPhone, initialState);
  const [phone, setPhone] = useState("");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 className={styles.authTitle}>Log in to <em className={styles.authTitleItalic}>Passage</em></h1>;
    t2 = <p className={styles.authSubtitle}>Enter your phone number to continue</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => setPhone(e.target.value);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isPending || $[4] !== phone) {
    t4 = <input type="tel" name="phone" value={phone} onChange={t3} placeholder="+1 (555) 123-4567" className={styles.authInput} autoFocus={true} required={true} disabled={isPending} />;
    $[3] = isPending;
    $[4] = phone;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== returnTo) {
    t5 = returnTo && <input type="hidden" name="returnTo" value={returnTo} />;
    $[6] = returnTo;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== state.error) {
    t6 = state.error && <p className={styles.errorText}>{state.error}</p>;
    $[8] = state.error;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `${styles.authButton} ${isPending ? styles.authButtonLoading : ""}`;
  let t8;
  if ($[10] !== isPending || $[11] !== phone) {
    t8 = isPending || !phone.trim();
    $[10] = isPending;
    $[11] = phone;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = isPending ? "Sending..." : "Continue";
  let t10;
  if ($[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <button type="submit" className={t7} disabled={t8}>{t9}</button>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t11 = <AuthPageLayout><AuthCard>{t1}{t2}<form action={formAction} className={styles.authForm}>{t4}{t5}{t6}{t10}</form></AuthCard></AuthPageLayout>;
    $[17] = t10;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}